import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './components/screen/App';

//styling
import './styles/css/App.css';
import './styles/css/index.css';

//scss
import './styles/styles.scss';





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


    <App />
 
);
